<div class="modal-body">
    <img class="icon mb-0" src="./../assets/images/cancelled-trips.svg" alt="logout">
    <h3 class="alertText">{{fromParent?.head}}</h3>
     
    <span class="alertContent"> <p [innerHTML]="fromParent?.content"></p></span>
    <div class="d-flex justify-content-center">
      <button class="button-blue btn"  (click)="hide()"> OK</button>      
    </div>  
  </div>
